import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Dropdown, Button, Menu, Modal } from "semantic-ui-react";
import { Link } from "react-router-dom";
import DataProviderForm from "../add-edit/components/DataProviderForm";
import { addNewDP, closeAddEditModal } from "../add-edit/actions/AddEditActions";
import DataSourcesForm from "../add-edit/components/DataSourcesForm";
import { validateDPService } from "../add-edit/actions/AddEditDPServiceActions";
import { validateDataProvider } from "../add-edit/actions/AddEditDPActions";
import { validateDPSource } from "../add-edit/actions/AddEditDPSourceActions";
import * as Validation from "../../common/utils/Validation";
import { signOut } from "../../auth/AuthActions";
import MARVEL from "../../common/utils/MarvelUrls";
import DPServicesForm from "../add-edit/components/DPServicesForm";

const createOptions = [
    { key: 1, text: 'Data Provider', value: "Data Provider" },
    { key: 2, text: 'DP Service', value: "DP Service" },
    { key: 3, text: 'DP Source', value: "DP Source" },
];
const value = null;

export class VeritasHeader extends Component {

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    // custom prop to enable the edit button passed
    // from detail pages if the user has editor rights
    static propTypes = {
        editAvailable: PropTypes.bool,
    }

    static defaultProps = {
        editAvailable: false,
    }

    handleDPCloseModal = () => {
        Validation.clearMessages();
        this.props.closeModal("Data Provider");
    }

    handleDPServiceCloseModal = () => {
        Validation.clearMessages();
        this.props.closeModal("DP Service");
    }

    handleDPSourceCloseModal = () => {
        Validation.clearMessages();
        this.props.closeModal("DP Source");
    }

    handleDPFormSubmit = () => {
        const { providerObject } = this.props;
        this.props.validateDataProvider(providerObject);
    }

    handleDPServiceFormSubmit = () => {
        const { serviceObject } = this.props;
        this.props.validateDPService(serviceObject, {});
    }

    handleDPSourceFormSubmit = () => {
        const { sourceObject } = this.props;
        const resourceType = sourceObject.service.service_type
        this.props.validateDPSource(sourceObject, resourceType, {});
    }

    handleChange(e, { value }) {
        e.preventDefault();
        this.props.createModal(value);
    }

    handleLogout = () => {
        this.props.signOut();
    }

    render() {

        const {
            dpModalHeader,
            dpServiceModalHeader,
            dpSourceModalHeader,
            modalOpenDP,
            modalOpenDPService,
            modalOpenDPSource,
        } = this.props;

        return (
            <div style={{ paddingBottom: "40px" }}>
                <Menu fixed="top">
                    <Menu.Item header>
                        <Link to={MARVEL.HOME}>Marvel</Link>
                    </Menu.Item>
                    <Menu.Item header>
                        <Link to={MARVEL.VERITAS.home}>Veritas</Link>
                    </Menu.Item>
                    <Menu.Item header>
                        <Link to={MARVEL.BILLING.home}>Billing</Link>
                    </Menu.Item>
                    <Menu.Item header disabled>
                        Configs
                    </Menu.Item>
                    <Menu.Item header disabled>
                        Batch
                    </Menu.Item>
                    <Menu.Item header disabled>
                        Reporting
                    </Menu.Item>
                    <Menu.Item header>
                        <Link to={MARVEL.SUPPORT.home}>Support</Link>
                    </Menu.Item>


                    <Menu.Menu position="right">
                        {this.props.editAvailable ?
                            (<Menu.Item>
                                <Button color={"yellow"}>Edit</Button>
                            </Menu.Item>)
                            : null
                        }
                        <Menu.Item position="right">
                            <Dropdown
                                selectOnBlur={false}
                                button
                                style={{ background: "#2185d0", color: "white" }}
                                onChange={this.handleChange}
                                options={createOptions}
                                placeholder='Create'
                                value={value}
                            />
                        </Menu.Item>

                        <Menu.Item>
                            <Link to={MARVEL.LOGOUT}>
                                <Button> Logout </Button>
                            </Link>
                        </Menu.Item>
                    </Menu.Menu>
                </Menu>

                <Modal
                    centered={false}
                    open={modalOpenDP}
                >
                    <Modal.Header>
                        {dpModalHeader}
                    </Modal.Header>
                    <Modal.Content>
                        <DataProviderForm />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            type="button"
                            color="red"
                            inverted
                            onClick={this.handleDPCloseModal}>
                            Close
                        </Button>
                        <Button
                            type="submit"
                            color="green"
                            inverted
                            onClick={this.handleDPFormSubmit}>
                            Submit
                        </Button>
                    </Modal.Actions>
                </Modal>

                <Modal
                    centered={false}
                    open={modalOpenDPService}
                >
                    <Modal.Header>
                        {dpServiceModalHeader}
                    </Modal.Header>
                    <Modal.Content scrolling>
                        <DPServicesForm />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            type="button"
                            color="red"
                            inverted
                            onClick={this.handleDPServiceCloseModal}>
                            Close
                        </Button>
                        <Button
                            type="submit"
                            color="green"
                            inverted
                            onClick={this.handleDPServiceFormSubmit}>
                            Submit
                        </Button>
                    </Modal.Actions>
                </Modal>

                <Modal
                    centered={false}
                    open={modalOpenDPSource}
                >
                    <Modal.Header>
                        {dpSourceModalHeader}
                    </Modal.Header>
                    <Modal.Content scrolling>
                        <DataSourcesForm />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            type="button"
                            color="red"
                            inverted
                            onClick={this.handleDPSourceCloseModal}>
                            Close
                        </Button>
                        <Button
                            type="submit"
                            color="green"
                            inverted
                            onClick={this.handleDPSourceFormSubmit}>
                            Submit
                        </Button>
                    </Modal.Actions>
                </Modal>
            </div>

        );
    }
}

const mapStateToProps = (state) => ({
    modalOpenDP: state.veritas.addEdit.addEditDP.modalOpenDP,
    providerObject: state.veritas.addEdit.addEditDP.providerObject,
    dpModalHeader: state.veritas.addEdit.addEditDP.dpModalHeader,

    modalOpenDPService: state.veritas.addEdit.addEditDPService.modalOpenDPService,
    dpServiceModalHeader: state.veritas.addEdit.addEditDPService.dpServiceModalHeader,
    serviceObject: state.veritas.addEdit.addEditDPService.serviceObject,

    modalOpenDPSource: state.veritas.addEdit.addEditDPSource.modalOpenDPSource,
    dpSourceModalHeader: state.veritas.addEdit.addEditDPSource.dpSourceModalHeader,
    sourceObject: state.veritas.addEdit.addEditDPSource.sourceObject,
    resultsArray: state.veritas.addEdit.addEditDPSource.resultsArray,
    inputsArray: state.veritas.addEdit.addEditDPSource.inputsArray,

});

const mapDispatchToProps = dispatch => ({
    signOut: () => { dispatch(signOut()) },
    createModal: (value) => { dispatch(addNewDP(value)) },
    closeModal: (type) => { dispatch(closeAddEditModal(type)) },

    validateDPService: (serviceObject, toDelete) => { dispatch(validateDPService(serviceObject, toDelete)) },
    validateDataProvider: (providerObject) => { dispatch(validateDataProvider(providerObject)) },
    validateDPSource: (sourceObject, resourceType, toDelete) => { dispatch(validateDPSource(sourceObject, resourceType, toDelete)) }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(VeritasHeader);
